import { TanStackDevtools } from '@tanstack/react-devtools';
import type { QueryClient } from '@tanstack/react-query';
import {
  createRootRouteWithContext,
  Navigate,
  Outlet,
} from '@tanstack/react-router';
import { TanStackRouterDevtoolsPanel } from '@tanstack/react-router-devtools';
import { fetchAuthSession, type AuthSession } from 'aws-amplify/auth';

import { Toaster } from '@components/ui/toaster';

import TanStackQueryDevtools from '../integrations/tanstack-query/devtools';

interface MyRouterContext {
  auth: {
    isAuthenticated: boolean;
    session?: AuthSession;
  };
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  beforeLoad: async () => {
    const session = await fetchAuthSession();
    return {
      auth: {
        isAuthenticated: !!session.tokens,
        session: session.tokens,
      },
    };
  },
  component: RootComponent,
  notFoundComponent: () => (
    <Navigate replace search={{ view: 'calls' }} to="/" />
  ),
});

function RootComponent() {
  return (
    <>
      <Outlet />
      <Toaster />
      <TanStackDevtools
        config={{
          openHotkey: ['ctrl-h'],
          position: 'bottom-left',
        }}
        plugins={[
          {
            name: 'Tanstack Router',
            render: <TanStackRouterDevtoolsPanel />,
          },
          TanStackQueryDevtools,
        ]}
      />
    </>
  );
}
